import type { MetaFunction } from 'react-router';

import { canonicalTag } from '@jane/bloom/resources/meta/canonicalTag';
import { description } from '@jane/bloom/resources/meta/description';
import { getRootLoaderData } from '@jane/bloom/resources/meta/getRootLoaderData';
import { parentMeta } from '@jane/bloom/resources/meta/parentMeta';
import { title } from '@jane/bloom/resources/meta/title';
import type { loader } from '@jane/bloom/routes/_menu.($storeSlug).deals._index/route';

export const DEFAULT_TITLE = `Deals | {{ storeName }}`;

export const dealsRouteMeta: MetaFunction<typeof loader> = (args) => {
  const {
    menuUrl,
    operator: { name },
    pinnedStore,
  } = getRootLoaderData(args);

  return [
    title('Deals', pinnedStore?.name || name),
    description(),
    canonicalTag(args.location, menuUrl),
    ...parentMeta(args),
  ];
};
